import styled from "styled-components";

export const ChartContent = styled.div`
  position: relative;
  overflow: hidden;
  display: grid;
  height: calc(100svh);
  grid-template-rows: calc(50% - 8px) calc(56%);
  gap: 16px;
`;

export const ChartGridBox = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TrendChartForm = styled.form`
  position: relative;
  height: calc(500vh);
`;

export const ExpandedModeControls = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const GridBottomButtonContainer = styled.div`
  position: sticky;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  z-index: 10;
`;

export const ExpandButtonPosition = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
`;
